import axios from 'axios'

export const getExtendedUser = async (accessToken: string) => {
  const baseUrl = window.APP_CONFIG.AUTHORITY

  const response = await axios.get(`${baseUrl}\\user`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })

  return response.data
}
